<template>
  <div class="mvc-add">
    <el-form ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="130px">
      <div class="base-info-box">
        <div class="title">基础信息</div>
        <el-form-item label="结算类型" prop="settlementType">
          <el-radio-group v-model="form.settlementType" @change="onSettlementTypeChange">
            <el-radio label="Settlement">门店结算</el-radio>
            <el-radio label="ReduceIncome">门店减收</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="储值卡名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入储值卡名称（最多10个字符）" maxLength="10" />
        </el-form-item>
        <el-form-item label="储值卡LOGO" prop="logo">
          <UploadImg name="logo" @getUploadFile="getUploadFile" :uploadUrl="form.logo" desc="建议：上传45x45的jpg、png、jpeg图片"></UploadImg>
        </el-form-item>
        <el-form-item label="储值卡封面" prop="cover">
          <UploadImg name="cover" @getUploadFile="getUploadFile" :uploadUrl="form.cover" :width="300" desc="建议：上传345x120的jpg、png、jpeg图片"></UploadImg>
        </el-form-item>

        <div class="range-select">
          <el-form-item label="使用范围" prop="useRangeType">
            <el-radio-group v-model="form.useRangeType" @change="onUseRangeTypeChange">
              <el-radio label="Generic">店铺通用</el-radio>
              <el-radio label="Store">指定店铺</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.useRangeType === 'Store'" class="store-select-box" prop="storeIds" label="" label-width="0">
            <el-cascader
              v-model="form.storeIds"
              placeholder="请选择店铺"
              :options="shopTreeData"
              :props="shopCascaderProps"
              clearable
              collapse-tags
              :filterable="true"
              :show-all-levels="false"
            >
            </el-cascader>
          </el-form-item>
        </div>

        <el-form-item label="储值卡面值" prop="amount" >
          <el-input type="text" v-model="form.amount" placeholder="请输入储值卡面值" oninput="value=value.replace(/[^.\d.]/g,'')"></el-input>
        </el-form-item>
        <!-- <el-form-item label="售价" prop="price" >
          <el-input type="text" v-model="form.price" placeholder="请输入售价" oninput="value=value.replace(/[^.\d.]/g,'')"></el-input>
          <span class="input-remark">（售价不允许大于面值）</span>
        </el-form-item> -->

        <div >
          <el-form-item label="商户承担比例" prop="costRate">
            <el-input type="text" v-model="form.costRate" :disabled="costRateDisabled" oninput="value=value.replace(/[^\d]/g,'')">
              <template slot="append">%</template>
            </el-input>
            <el-tooltip class="tooltip" placement="right" effect="light">
              <i class="el-icon-question"></i>
              <div slot="content">
                <div>C端客户购卡后，T + 1日结算给商场</div>
                <div>商场结算金额 = 售价 *（1 - 西瓜收取的服务费比例）</div>
                <div>C端客户核销后，T + 1日计算给商户 </div>
                <div>商户结算金额 =（核销金额 / 面值）* 面值 *（1 - 交易手续费比例 - 租金扣点比例 - 商户承担比例）</div>
              </div>
            </el-tooltip>
          </el-form-item>
        </div>
        <el-form-item label="可售数量" prop="quantityLimit" >
          <el-input type="text" v-model="form.quantityLimit" placeholder="请输入可售数量" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="有效期" prop="effectiveType" >
          <el-radio-group v-model="form.effectiveType">
            <el-radio label="Fixed">固定时间</el-radio>
            <el-radio label="Unfixed">指定时间</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.effectiveType == 'Fixed'" prop="fixedTime" label="" label-width="130px">
          <el-date-picker
            v-model="form.fixedTime"
            type="daterange"
            range-separator=""
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            format="yyyy/MM/dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-if="form.effectiveType == 'Unfixed'" label="" prop="effectiveMonth" label-width="240px" >
          <el-input type="text" v-model="form.effectiveMonth" oninput="value=value.replace(/[^\d]/g,'')">
            <template slot="prepend">购卡成功后</template>
            <template slot="append">个月内有效</template>
          </el-input>
        </el-form-item>
         <el-form-item label="优惠券" prop="coupons">
        <el-select v-model="form.coupons" placeholder="请选择优惠券" @change="v => onCouponChange(v, 'coupon')" multiple collapse-tags filterable>
          <el-option v-for="item in couponListData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <div class="coupon-table">
        <Table :tableThData="tableThData_coupon" :tableTrData="tableTrData_coupon" :pagination="false" >
          <template #name="{ row }">{{ row.name }}</template>
          <template #type="{ row }">{{ row.type }}</template>
          <template #detail="{ row }">{{ row.detail }}</template>
          <template #require="{ row }">{{ row.require }}</template>
          <template #useTime="{ row }">{{ row.useTime }}</template>
          <template #amount="{ scope }">
            <el-form-item label-width="0" prop="amount" :rules="[{validator: (r, v, c) => checkTableForm(r, v, c, scope, 'tableTrData_coupon')}]" >
              <el-input v-model="tableTrData_coupon[scope.$index].amount" maxlength="2"  placeholder="请输入" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" style="width: 80px;" />
            </el-form-item>
          </template>
        </Table>
      </div>
      <el-form-item label="礼品券" prop="giftCoupons">
        <el-select v-model="form.giftCoupons" placeholder="请选择礼品券" @change="v => onCouponChange(v, 'gift')" multiple collapse-tags filterable>
          <el-option v-for="item in giftCouponListData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <div class="coupon-table">
        <Table :tableThData="tableThData_gift" :tableTrData="tableTrData_gift" :pagination="false" >
          <template #name="{ row }">{{ row.name }}</template>
          <template #subTitle="{ row }">{{ row.subTitle }}</template>
          <template #useTime="{ row }">{{ row.useTime }}</template>
          <template #useRangeType="{ row }">{{ row.useRangeType }}</template>
          <template #description="{ row }">
            <el-button v-if="row.description" type="text" @click="onLookRemark(row)">查看使用须知</el-button>
            <span v-else>---</span>
          </template>
          <template #amount="{ scope }">
            <el-form-item label-width="0" prop="amount" :rules="[{validator: (r, v, c) => checkTableForm(r, v, c, scope, 'tableTrData_gift')}]" >
              <el-input v-model="tableTrData_gift[scope.$index].amount" maxlength="2"   placeholder="请输入" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" style="width: 80px;" />
            </el-form-item>
          </template>
        </Table>
      </div>
      <el-form-item label="停车券" prop="parkingCoupons">
        <el-select v-model="form.parkingCoupons" placeholder="请选择停车券" @change="v => onCouponChange(v, 'parkingCoupons')" multiple collapse-tags filterable>
          <el-option v-for="item in parkingCouponListData" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <div class="coupon-table">
        <Table :tableThData="tableThData_parking" :tableTrData="tableTrData_parking" :pagination="false" >
          <template #name="{ row }">{{ row.name }}</template>
          <template #discount="{ row }">{{ row.discount }}</template>
          <template #validTime="{ row }">{{ row.validTime }}</template>
          <template #mallName="{ row }">{{ row.mallName }}</template>
          <template #remark="{ row }">
            <el-button v-if="row.remark" type="text" @click="onLookRemark(row,'parking')">查看使用须知</el-button>
            <span v-else>---</span>
          </template>
          <template #amount="{ scope }">
            <el-form-item label-width="0" prop="amount" :rules="[{validator: (r, v, c) => checkTableForm(r, v, c, scope, 'tableTrData_parking')}]" >
              <el-input v-model="tableTrData_parking[scope.$index].amount" maxlength="2"   placeholder="请输入" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" style="width: 80px;" />
            </el-form-item>
          </template>
        </Table>
      </div>
        <el-form-item label="使用规则" prop="rule">
          <el-input type="textarea" rows="6" v-model="form.rule" placeholder="请输入使用规则" maxlength="500" show-word-limit />
          <el-tooltip class="tooltip" placement="right" effect="light">
            <i class="el-icon-question"></i>
            <div slot="content">
              <div>样列：</div>
              <div>1. 本储值卡仅限于本商场内消费使用，具体支持的品牌与门店请在购买详情内查看；</div>
              <div>2. 储值卡售出后允许退换与兑换现金、不找零；</div>
              <div>3. 储值卡与西瓜平台优惠券可同时使用，优惠券的满减金额以扣除储值卡抵扣金额后的订单金额为准；</div>
              <div>4. 购买储值卡无法开具发票，如需发票请谨慎购买；</div>
              <div>5. 储值卡有效期为3年，过期失效。</div>
              <div>6. 使用过储值卡金额的订单不支持部分退款；订单退款成功后已使用的储值卡金额自动退还，有效期不变；</div>
              <div>7. 可重复购买，有效期累计计算</div>
            </div>
          </el-tooltip>
        </el-form-item>
        <!-- <el-form-item label="是否允许退款" prop="allowRefund">
          <el-radio-group v-model="form.allowRefund">
            <el-radio :label="false">不允许</el-radio>
            <el-radio :label="true">允许</el-radio>
          </el-radio-group>
        </el-form-item> -->
      </div>
    </el-form>
    <div class="footer">
      <el-button @click="onBack" class="mr20">取消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="submitLoading">提交</el-button>
    </div>
    <el-dialog :visible="isShowRemarkDialog" title="使用须知" :before-close="() => this.isShowRemarkDialog = false" width="30%">
      <div class="remark-box" v-html="currentRow.description"></div>
    </el-dialog>
  </div>
</template>

<script>
import UploadImg from '@/components/UploadImg/index'
import Table from "@/components/Table/index";
import { post_getValueCardAdd } from '@/api/market'
import { api_getConfig, api_postFileUpload,api_getListCoupon, api_getGiftListCoupon } from '@/api/common'
import { api_getParkingCouponTemplate } from '@/api/parking'
export default {
  name: "mvcAdd",
  components: {
    UploadImg,
    Table
  },
  data() {
    // 校验面值
    const checkAmount = (rule, value, callback) => {
      const check = /^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
      if (value && !check.test(value)) {
        callback(new Error('请输入储值卡面值，最多保留两位小数'))
      } else if (!value) {
        callback(new Error('请输入储值卡面值'))
      } else {
        callback()
      }
    }

    // 校验售价
    const checkPrice = (rule, value, callback) => {
      const check = /^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
      if (value && !check.test(value)) {
        callback(new Error('请输入售价，最多保留两位小数'))
      } else if (value > parseFloat(this.form.amount)) {
        callback(new Error('售价不允许大于面值'))
      } else if (!value) {
        callback(new Error('请输入售价'))
      } else {
        callback()
      }
    }

    const checkFail = (rule, value, callback) => {
      if (rule.field == 'logo' && !this.form.logo) {
        callback(new Error('请上传储值卡LOGO'))
      } else if (rule.field == 'cover' && !this.form.cover) {
        callback(new Error('请上传储值卡封面'))
      } else {
        callback()
      }
    }

    const checkCostRate = (rule, value, callback) => {
      if (value && (parseInt(value) < 1 || parseInt(value) > 100)) {
        callback(new Error('请输入1~100的整数'))
      } else {
        callback()
      }
    }

     // 校验表格中的输入框
    const checkTableForm = (rule, v, callback, scope, tableName) => {
      const { field } = rule
      const { $index } = scope
      const value = this[tableName][$index][field]
      if (field == 'amount' && !value) {
        callback(new Error('请输入'))
      } else {
        callback()
      }
    }

    return {
      submitLoading: false,
      isShowRemarkDialog:false,
      currentRow:{},
      costRateDisabled: false, // 禁用商户承担比例
      form: {
        disable: false,
        storeIds: [],
        effectiveType: 'Fixed',
        costRate: ''
      },
      rules: {
        settlementType: [{ required: true, message: '请选择结算类型' }],
        name: [{ required: true, message: '请输入店铺名称' }],
        logo: [{ validator: checkFail }],
        cover: [{ validator: checkFail }],
        amount: [{ validator: checkAmount }],
        // price: [{ validator: checkPrice }],
        useRangeType: [{ required: true, message: '请选择使用范围' }],
        storeIds: [{ required: true, message: '请选择店铺' }],
        costRate: [{ required: true, message: '请输入商户承担比例' }, { validator: checkCostRate }],
        fixedTime: [{ required: true, message: '请选择时间' }],
        effectiveMonth: [{ required: true, message: '请输入' }],
        quantityLimit: [{ required: true, message: '请输入可售数量' }],
        rule: [{ required: true, message: '请输入使用规则' }],
      },
      checkTableForm,
      couponListData: [], // 优惠券list数据
      giftCouponListData: [], // 礼品券list数据
      parkingCouponListData: [], // 停车券list数据
      tableThData_coupon: [
        { prop: "name", label: "优惠券名称", minWidth: "120", },
        { prop: "type", label: "优惠券类型", minWidth: "120", },
        { prop: "detail", label: "券优惠", minWidth: "120", },
        { prop: "require", label: "券门槛", minWidth: "120", },
        { prop: "useTime", label: "用券时间", minWidth: "120", },
        { prop: "amount", label: "每人可赠数量", minWidth: "120",},
      ],
      tableTrData_coupon: [],
      tableThData_gift: [
        { prop: "name", label: "礼品券名称", minWidth: "120", },
        { prop: "subTitle", label: "标题", minWidth: "120", },
        { prop: "useTime", label: "券有效时间", minWidth: "120", },
        { prop: "useRangeType", label: "核销范围", minWidth: "120", },
        { prop: "description", label: "使用须知", minWidth: "120", },
        { prop: "amount", label: "每人可赠数量", minWidth: "120",},
      ],
      tableTrData_gift: [],
      tableThData_parking: [
        { prop: "name", label: "停车券名称", minWidth: "120", },
        { prop: "discount", label: "抵扣优惠", minWidth: "120", },
        { prop: "validTime", label: "券有效时间", minWidth: "120", },
        { prop: "mallName", label: "使用范围", minWidth: "120", },
        { prop: "remark", label: "使用须知", minWidth: "120", },
        { prop: "amount", label: "每人可赠数量", minWidth: "120",},
      ],
      tableTrData_parking: [],
      shopTreeData: [], // 店铺级联框树形数据
      shopCascaderProps: {
        multiple: true,
        value: "id",
        label: "name",
        emitPath: false,
      }, // 店铺级联框配置项

    };
  },
  async created() {
    this.getConfigData() // 获取店铺级联框
    await this.getCouponListData() // 获取优惠券列表数据
    await this.getGiftCouponListData() // 获取礼品券列表数据
    await this.getParkingCouponListData() // 获取停车券券列表数据
    this.$route.meta.title = '创建储值卡'
  },
  mounted() {},
  methods: {
    // 获取店铺级联框数据
    async getConfigData() {
      let {storeThreeLevel} = await api_getConfig(['storeThreeLevel'])
      this.shopTreeData = storeThreeLevel
    },
      // 获取优惠券列表数据
    async getCouponListData() {
      const res = await api_getListCoupon()
      this.couponListData = res
    },

    // 获取礼品券列表数据
    async getGiftCouponListData() {
      const res = await api_getGiftListCoupon()
      this.giftCouponListData = res
    },

    // 获取停车券列表数据
    async getParkingCouponListData() {
      const res = await api_getParkingCouponTemplate()
      this.parkingCouponListData = res
    },
    // 查看使用须知
    onLookRemark(row,type) {
      this.currentRow = row
      if(type == 'parking'){
        this.currentRow.description = row.remark
      }
      this.isShowRemarkDialog = true
    },
    // 使用范围改变
    onUseRangeTypeChange() {
      this.form.storeIds = []
    },

    // 结算类型改变
    onSettlementTypeChange(value) {
      this.form.costRate = value == 'ReduceIncome' ? '100' : ''
      this.costRateDisabled = value == 'ReduceIncome'
    },

    // 优惠券下拉框改变
    onCouponChange(value, type) {
      if (type == 'coupon') {
        this.$refs.form.validateField('giftCoupons')
        let curCoupon = this.couponListData.filter(item => value.indexOf(item.id) >= 0)
        this.tableTrData_coupon = curCoupon.map(item => {
          let curTable = this.tableTrData_coupon.filter(el => el.id == item.id)
          return curTable.length ? curTable[0] : item
        })
      } else if(type == 'gift'){
        this.$refs.form.validateField('coupons')
        let curCoupon = this.giftCouponListData.filter(item => value.indexOf(item.id) >= 0)
        this.tableTrData_gift = curCoupon.map(item => {
          let curTable = this.tableTrData_gift.filter(el => el.id == item.id)
          return curTable.length ? curTable[0] : item
        })
      }else{
          this.$refs.form.validateField('parkingCoupons')
          let curCoupon = this.parkingCouponListData.filter(item => value.indexOf(item.id) >= 0)
          this.tableTrData_parking = curCoupon.map(item => {
          let curTable = this.tableTrData_parking.filter(el => el.id == item.id)
          return curTable.length ? curTable[0] : item
        })
      }
    },
    // 处理优惠券、礼品券保存数据
    disposeCoupons(type) {
      let listData = []
      switch (type) {
        case 'coupon':
          listData =  this.tableTrData_coupon
          break;
        case 'gift':
          listData =  this.tableTrData_gift
          break;
        case 'parking':
          listData =  this.tableTrData_parking
          break;
        default:
          break;
      }
      return listData.map(item => {
        const { id, amount } = item
        return {
          couponTemplateId:id,
          count:amount,
        }
      })
    },
    // 点击提交按钮
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.created()
        }
      })
    },

    // 创建
    async created() {
      this.submitLoading = true
      try {
        let params = {
          ...this.form,
          giveCouponInfo: {
            runtuCouponTemplates: this.disposeCoupons('coupon'),
            giftCouponTemplates: this.disposeCoupons('gift'),
            lotCouponTemplates: this.disposeCoupons('parking'),
          }
        }
         delete params.coupons
         delete params.giftCoupons
         delete params.parkingCoupons
        // 上传图片
        if (this.form.logo && this.form.logo.size) {
          const { key } = await api_postFileUpload(this.form.logo, 'CardLogo')
          params.logo = key
        }
        if (this.form.cover && this.form.cover.size) {
          const { key } = await api_postFileUpload(this.form.cover, 'CardCover')
          params.cover = key
        }

        // 处理用券时间---固定时间的时间值
        if (this.form.effectiveType == 'Fixed') {
          params.startTime = this.form.fixedTime ? this.$moment(this.form.fixedTime[0]).valueOf() : null // 券有效期-开始
          params.endTime = this.form.fixedTime ? this.$moment(this.form.fixedTime[1]).valueOf() : null // 券有效期-结束
        }
        delete params.fixedTime

        // if (params.amount == params.price) {
        //   delete params.costRate
        // }
        console.log('params: ', params);
        // return

        await post_getValueCardAdd(params)
        this.$baseMessage('操作成功', 'success')
        this.onBack()
        this.submitLoading = false
      } catch (error) {
        console.log('error: ', error);
        this.submitLoading = false
      }
    },

    getUploadFile (file, name) {
      this.form[name] = file
    },

    // 返回
    onBack() {
      this.$router.back(-1)
    },
  },
};
</script>

<style lang="scss" scoped>
.mvc-add {
  width: 100%;
  padding: 35px 20px;
  padding-bottom: 100px;
  box-sizing: border-box;
  position: relative;

  .range-select {

    .store-select-box {
      margin-left: 240px;
      margin-top: -20px;
    }
  }

  .el-icon-question {
    margin-left: 10px;
    color: #999999;
    font-size: 16px;
  }

  .title {
    margin: 0;
    margin-bottom: 30px;
    padding-left: 15px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    .title-remark {
      color: #666666;
      font-size: 14px;
    }

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05C8AF;
    }
  }
  .remark-box {
    width: 100%;
    min-height: 300px;
    max-height: 500px;
    overflow: auto;

    &::v-deep img {
      width: 100% !important;
    }
  }
  .coupon-table {
    width: 90%;
    margin-left: 130px;
    margin-bottom: 20px;

    .table-price-box {
      display: flex;

      .text {
        height: 34px;
        line-height: 34px;
        margin: 0 10px;
      }
    }
  }
  .input-remark {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
    position: absolute;
    left: 350px;
    bottom: 0;
  }

  .el-input,
  .el-textarea,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 350px;
  }

  .footer{
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    z-index:1000;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
  }
}
</style>
